"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GirlIcon = void 0;
const react_1 = require("react");
const React = require("react");
const icon_1 = require("./icon");
class GirlIcon extends react_1.Component {
    render() {
        const { fill = icon_1.ICON_COLORS.fill } = this.props;
        return (React.createElement("svg", { width: "24px", height: "24px", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
            React.createElement("g", { stroke: "none", strokeWidth: "1", fill: fill, fillRule: "evenodd" },
                React.createElement("g", { fill: fill },
                    React.createElement("g", { transform: "translate(6.000000, 0.000000)" },
                        React.createElement("path", { d: "M6.5,8 C8.706,8 10.5,6.206 10.5,4 C10.5,1.794 8.706,0 6.5,0 C4.294,0 2.5,1.794 2.5,4 C2.5,6.206 4.294,8 6.5,8" }),
                        React.createElement("path", { d: "M6.5,9 C3.136,9 0.5,13.173 0.5,18.5 C0.5,18.776 0.724,19 1,19 L4,19 L4,23.5 C4,23.776 4.224,24 4.5,24 L8.5,24 C8.776,24 9,23.776 9,23.5 L9,19 L12,19 C12.276,19 12.5,18.776 12.5,18.5 C12.5,13.173 9.864,9 6.5,9" }))))));
    }
}
exports.GirlIcon = GirlIcon;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/girl.tsx
// module id = 2145
// module chunks = 0 1 2